import store from '../store';

export default {
  methods: {
    askIfTokenHasBeenChanged() {
      const msg = {
        name: process.env.VUE_APP_IFRAME_MESSAGE_CHECK_TOKEN_REFRESH,
        tId: this.tId,
      };
      window.parent.postMessage(msg, document.referrer);
    },
    listenMessages() {
      return new Promise((resolve) => {
        const listenCallback = (e) => {
          const msg = e.data;
          if (!msg) resolve();
          // eslint-disable-next-line default-case
          switch (msg.name) {
            case 'refreshToken':
              if (msg.data) {
                store.commit('setClientToken', msg.data);
              }
              resolve(1)
              break;
            case 'updateProfile':
              this.user = msg.data
              store.commit('setProfileName', msg.data.name);
              if (this.checkoutComponent) {
                this.checkoutComponent.userInfo = msg.data
              }
              resolve();
              break;
            case 'setReturnUrls':
              store.commit('setReturnSuccessUrl', msg.data.paymentSuccessUrl)
              store.commit('setReturnErrorUrl', msg.data.paymentErrorUrl)
              break;
            case 'hideLogginInSpinner':
              setTimeout(() => {
                if (this.showLoader) {
                  this.showLoader = false;
                }
                if (!this.showOffer) {
                  this.showOffer = true;
                }
              }, 7000)
              resolve();
              break;
            case 'korabTest':
              this.braintree.initializeTokenizeKorab();
              resolve();
              break;
            default:
              resolve()
          }
        };
        window.addEventListener('message', listenCallback);
      });
    },
  },
}
